export interface CardImage {
  src: string;
  width: number;
  height: number;
}

export interface Card {
  id: number;
  name: string;
  description: string;
  image: CardImage;
  link: string;
}

export const Cards: Card[] = [
  {
    id: 1,
    name: 'Agendar Consulta',
    description: 'Ofereça aos seus pacientes um agendamento rápido, seguro e sem complicações.',
    image: {
      src: 'lp-ecosystem-agenda-consulta.svg',
      width: 197,
      height: 32,
    },
    link: 'https://agendarconsulta.com/',
  },
  {
    id: 2,
    name: 'Afya iClinic',
    description: 'Gestão clínica eficiente em uma solução completa para médicos.',
    image: {
      src: 'lp-ecosystem-afya-clinic.svg',
      width: 166,
      height: 32,
    },
    link: 'https://iclinic.com.br/',
  },
  {
    id: 3,
    name: 'Cliquefarma',
    description: 'Compare preços de medicamentos e itens de saúde de forma prática.',
    image: {
      src: 'lp-ecosystem-cliquefarma.svg',
      width: 149,
      height: 50,
    },
    link: 'https://www.cliquefarma.com.br/',
  },
  {
    id: 4,
    name: 'Glic Afya',
    description: 'O primeiro app do Brasil para o tratamento completo do diabetes.',
    image: {
      src: 'lp-ecosystem-glic-afya.svg',
      width: 115,
      height: 32,
    },
    link: 'https://gliconline.net/',
  },
  {
    id: 5,
    name: 'Afya Educação Médica',
    description: 'Amplie sua carreira com uma pós-médica em diversas especialidades.',
    image: {
      src: 'lp-ecosystem-afya-educacao-medica.svg',
      width: 139,
      height: 32,
    },
    link: 'https://www.afya.com.br/pos-graduacao/',
  },
  {
    id: 6,
    name: 'RX Pro',
    description: 'Solicite amostras grátis e receba no seu consultório com total segurança.',
    image: {
      src: 'lp-ecosystem-rx-pro.svg',
      width: 77,
      height: 48,
    },
    link: 'https://rxpro.com.br/',
  },
  {
    id: 7,
    name: 'Portal Afya',
    description: 'Atualize-se com notícias, vídeos e podcasts sobre a área médica.',
    image: {
      src: 'lp-ecosystem-portal-afya.svg',
      width: 159,
      height: 31,
    },
    link: 'https://portal.afya.com.br/',
  },
  {
    id: 8,
    name: 'Medcel Afya',
    description: 'Prepare-se para a residência com professores e conteúdos exclusivos.',
    image: {
      src: 'lp-ecosystem-medcel-afya.svg',
      width: 186,
      height: 26,
    },
    link: 'https://medcel.com.br/',
  },
];
